import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Logo } from './UI';
import { useAuth } from '../context/AuthContext';

const NAV = [
  { path: '/dashboard',              icon: '📊', label: 'Dashboard' },
  { path: '/dashboard/crm',          icon: '👥', label: 'CRM Contacts' },
  { path: '/dashboard/whatsapp',     icon: '📱', label: 'WhatsApp' },
  { path: '/dashboard/campaigns',    icon: '📤', label: 'Campaigns' },
  { path: '/dashboard/autoreply',    icon: '🤖', label: 'Auto Reply Bot' },
  { path: '/dashboard/widget',       icon: '🔌', label: 'Widget' },
  { path: '/dashboard/analytics',    icon: '📈', label: 'Analytics' },
  { path: '/dashboard/billing',      icon: '💳', label: 'Billing' },
  { path: '/dashboard/tickets',      icon: '🎫', label: 'Support' },
  { path: '/dashboard/notifications',icon: '🔔', label: 'Notifications' },
  { path: '/dashboard/profile',      icon: '⚙️',  label: 'Profile' },
];

export default function DashLayout({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout, user } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: 'var(--bg)' }}>
      {sidebarOpen && <div onClick={() => setSidebarOpen(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 99 }} />}

      {/* SIDEBAR */}
      <aside style={{ width: 240, flexShrink: 0, background: '#0d0d0d', borderRight: '1px solid rgba(255,255,255,0.06)', display: 'flex', flexDirection: 'column', position: 'fixed', top: 0, left: 0, bottom: 0, zIndex: 100, overflowY: 'auto', transition: 'transform 0.3s', transform: sidebarOpen ? 'none' : undefined }}>
        <div style={{ padding: '18px 16px 14px', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
          <Logo size={34} />
        </div>
        <nav style={{ flex: 1, padding: '10px 8px', display: 'flex', flexDirection: 'column', gap: 2 }}>
          {NAV.map(item => {
            const active = location.pathname === item.path || (item.path !== '/dashboard' && location.pathname.startsWith(item.path));
            return (
              <Link key={item.path} to={item.path} onClick={() => setSidebarOpen(false)} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '9px 12px', borderRadius: 8, color: active ? '#ffffff' : 'rgba(255,255,255,0.35)', background: active ? 'rgba(0,231,76,0.12)' : 'transparent', fontSize: 13, fontWeight: active ? 600 : 400, transition: 'all 0.15s', textDecoration: 'none', borderLeft: active ? '2px solid var(--green)' : '2px solid transparent' }}>
                <span style={{ fontSize: 15, width: 20, textAlign: 'center' }}>{item.icon}</span>
                {item.label}
              </Link>
            );
          })}
        </nav>
        <div style={{ padding: 14, borderTop: '1px solid rgba(255,255,255,0.06)' }}>
          <button onClick={handleLogout} style={{ width: '100%', background: 'transparent', border: '1px solid rgba(255,255,255,0.08)', color: 'rgba(255,255,255,0.4)', padding: '9px 12px', borderRadius: 8, fontSize: 13, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8, transition: 'all 0.2s' }}
            onMouseOver={e => { e.currentTarget.style.borderColor = '#ff4444'; e.currentTarget.style.color = '#ff6b6b'; }}
            onMouseOut={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)'; e.currentTarget.style.color = 'rgba(255,255,255,0.4)'; }}
          >🚪 Logout</button>
        </div>
      </aside>

      {/* MAIN */}
      <main style={{ flex: 1, marginLeft: 240, minWidth: 0 }}>
        {/* Topbar */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 24px', borderBottom: '1px solid rgba(255,255,255,0.06)', background: '#0d0d0d', position: 'sticky', top: 0, zIndex: 50 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <button onClick={() => setSidebarOpen(!sidebarOpen)} style={{ background: 'none', border: 'none', color: '#fff', fontSize: 20, cursor: 'pointer', display: 'none' }} className="hamburger">☰</button>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <Link to="/dashboard/notifications" style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 8, padding: '7px 10px', fontSize: 16, textDecoration: 'none' }}>🔔</Link>
            <div style={{ background: 'rgba(0,231,76,0.1)', border: '1px solid rgba(0,231,76,0.2)', color: 'var(--green)', padding: '7px 16px', borderRadius: 8, fontSize: 13, fontWeight: 600 }}>{user?.name || 'User'}</div>
          </div>
        </div>
        <div style={{ padding: 24, animation: 'fadeIn 0.25s ease', color: '#ffffff' }}>
          {children}
        </div>
      </main>

      <style>{`
        * { color: inherit; }
        .dashboard-text { color: #ffffff !important; }
        @media (max-width: 768px) {
          main { margin-left: 0 !important; }
          .hamburger { display: block !important; }
          aside { transform: translateX(-100%); }
          ${sidebarOpen ? 'aside { transform: none !important; }' : ''}
        }
      `}</style>
    </div>
  );
}
